import { configureStore, PreloadedState } from '@reduxjs/toolkit'
import { rootReducer } from './reducer'
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit'

export function configure(preloadedState: PreloadedState<RootState> = {}) {
  const store = configureStore({
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    reducer: rootReducer,
    preloadedState,
  })

  return store
}

export const store = configure()

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof configure>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = ThunkDispatch<AppStore, unknown, AnyAction>
